import { useState } from "react";
import { GoPlusCircle } from "react-icons/go";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa";





const faqs = [
    {
        q: "What is Message Notifier used for?",
        a: "Message Notifier is a business messaging platform that helps companies send notifications, manage customer conversations, and automate replies through messaging channels like WhatsApp. It is designed to improve customer engagement, response time, and communication efficiency."
    },
    {
        q: "Can I automate customer replies using Message Notifier?",
        a: "Yes. Message Notifier allows you to automate replies using smart workflows and predefined responses. You can instantly answer common questions, collect customer details, send confirmations, and follow up automatically without manual intervention."
    },
    {
        q: "Is Message Notifier suitable for small businesses?",
        a: "Absolutely. Message Notifier is built for businesses of all sizes. Small businesses can use it to manage customer inquiries efficiently, while growing teams can scale messaging operations without increasing workload or complexity."
    },
    {
        q: "How does the unified inbox work?",
        a: "The unified inbox brings all customer conversations into one centralized dashboard. Your team can view message history, respond faster, and collaborate easily without switching between multiple tools or platforms."
    },
    {
        q: "Do I need technical knowledge to use Message Notifier?",
        a: "No technical expertise is required. Message Notifier is designed with a user-friendly interface and simple setup process, allowing anyone to start sending messages and managing conversations quickly."
    }
];

export default function FAQContactSection() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    

    return (
        <section className="faq-section py-5 py-lg-6 font-inter">
            
            <header className="text-center mb-5">
                <h2 className="font-spacegrotesk fw-semibold text-purple fs-2 fs-sm-3 fs-md-4">
                    Frequently Asked Questions (FAQs)
                </h2>
            </header>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-8">

                        <div className="bg-white rounded-3 p-1">
                            <div className="rounded-3">

                                {faqs.map((item, index) => (
                                    <div
                                        key={index}
                                        className="position-relative py-4"
                                    >
                                       
                                        {index !== faqs.length - 1 && (
                                            <div className="position-absolute bottom-0 start-0 w-100 border-bottom border-purple-gray"></div>
                                        )}

                                      
                                        <div
                                            className="d-flex align-items-center gap-3 px-3 cursor-pointer"
                                            onClick={() => toggleFAQ(index)}
                                        >
                                            {openIndex === index ? (
                                                <FaMinus size={22} className="text-neon-purple" />
                                            ) : (
                                                <FaPlus size={22} className="text-neon-purple" />
                                            )}

                                            <p className="mb-0 font-spacegrotesk fw-medium text-dark fs-6 fs-md-5">
                                                {item.q}
                                            </p>
                                        </div>

                                        
                                        <div
                                            className={`overflow-hidden transition-all px-3 ${openIndex === index ? "faq-open mt-2" : "faq-close"
                                                }`}
                                        >
                                            <p className="mt-2 ms-5 mb-0 font-spacegrotesk text-secondary fs-6">
                                                {item.a}
                                            </p>
                                        </div>

                                    </div>
                                ))}

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>

    );
}
